import React from "react"
import { Scorer } from "../../models/Scorer"
import { IList, openTwitch } from "../../models/Utils"
import { UserAvatar } from "./UserAvatar"

export class ClassificationTable extends React.Component<IList<Scorer>>{
    T1 = (p: React.PropsWithChildren) => <div className="col-2 col-md-1 text-center">{p.children}</div>
    T2 = (p: React.PropsWithChildren) => <div className="col-6 col-md-7 text-truncate">{p.children}</div>
    T3 = (p: React.PropsWithChildren) => <div className="col-2 col-md-2 text-center">{p.children}</div>
    T4 = (p: React.PropsWithChildren) => <div className="col-2 col-md-2 text-center text-truncate">{p.children}</div>

    render = () => {
        const { T1, T2, T3, T4 } = this

        return <>
            <div className="row mt-4">
                <T1>
                    <strong>#</strong>
                </T1>
                <T2>
                    <strong>Utente</strong>
                </T2>
                <T3>
                    <strong>Punti</strong>
                </T3>
                <T4>
                    <strong>Risposte</strong>
                </T4>
            </div>

            {
                this.props.list.map((l, i) => <div className="row table-item mt-2 align-items-center shadow-sm" key={l.username}>
                    <T1>
                        <span className="position-tag">{i + 4}</span>
                    </T1>
                    <T2>
                        <span className="user-link" onClick={() => openTwitch(l.username)}>
                            <UserAvatar username={l.username} /> @{l.username}
                        </span>
                    </T2>
                    <T3>
                        {l.points}
                    </T3>
                    <T4>
                        {l.aQuestions}
                    </T4>
                </div>)
            }
        </>
    }
}